import { type IBuyerBillingQuery } from 'application/querySchemas/IBuyerBillingQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import {
    type IBuyerBillingListClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerBillingListClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class BuyerBillingQuery implements IBuyerBillingQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerBillingListClient')
        public readonly buyerBillingListClient: IBuyerBillingListClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerBillingListClient.get({
            token: this.buyerUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
